import {httpGet, httpPost} from '@/util/request.js';
import appConfig from "@/config";

export default class AlarmOrderApi {

    static baseUrl = appConfig.gatewayUrl + appConfig.alarmOrdersPath + '/h5/workOrder/';
    // static baseUrl = 'http://10.254.121.186:10023/h5/workOrder/';

    /**
     * 获取预警消息统计
     */
    static getMsgCountInfo(param) {
        return this.httpRequest('alarm/msgAmount', param, 'post')
    }

    /**
     * 获取预警消息列表
     */
    static getMsgList(param) {
        return this.httpRequest('alarm/msgList', param, 'post')
    }


    /**
     * 获取预警任务统计
     */
    static getTaskCountInfo(param) {
        return this.httpRequest('alarm/taskAmount', param, 'post')
    }


    /**
     * 获取预警任务列表
     */
    static getTaskList(param) {
        return this.httpRequest('alarm/taskList', param, 'post')
    }

    /**
     * 修改预警工单详情状态
     */
    static editAlarmOrderStatus(param) {
        return this.httpRequest('alarm/editAlarmOrderStatus', param,'post');
    }


    /**
     * 任务提交
     */
    static taskSubmit(param) {
        return this.httpRequest('alarm/reply', param, 'post')
    }


    /**
     * 任务审阅
     */
    static taskAudit(param) {
        return this.httpRequest('alarm/audit', param, 'post')
    }


    /**
     * 任务驳回
     */
    static taskReject(param) {
        return this.httpRequest('alarm/reject', param, 'post')
    }


    /**
     * 获取本人全部任务列表
     */
    static getTaskAllList(param) {
        return this.httpRequest('alarm/getTaskAllList', param, 'post')
    }


    /**
     * 获取本人审阅任务列表
     */
    static getTaskAuditList(param) {
        return this.httpRequest('alarm/getTaskAuditList', param, 'post')
    }


    /**
     * 获取历史任务明细
     */
    static getTaskDetailedList(param) {
        return this.httpRequest('alarm/getTaskDetailedList', param, 'post')
    }


    /**
     * 获取任务回复
     */
    static getReply(param) {
        return this.httpRequest('alarm/getReply', param, 'post')
    }


    /**
     * 获取任务驳回记录
     */
    static getRejectInfo(param) {
        return this.httpRequest('alarm/getRejectInfo', param, 'post')
    }

    /**
     * 获取毛利率详情
     * @param param
     * @returns {undefined}
     */
    static getRateDetail(param) {
        return this.httpRequest('alarm/searchGrossProfitRateDetail', param, 'post');
    }


    /**
     * 获取客流详情
     */
    static getPassengerFlowDetail(param) {
        return this.httpRequest('alarm/searchPassengerFlowDetail', param, 'post')
    }


    /**
     * 获取空铺详情
     */
    static getEmptyShopDetail(param) {
        return this.httpRequest('alarm/searchEmptyShopDetail', param, 'post')
    }


    /**
     * 获取商圈预警详情
     */
    static getTradingAreaDetail(param) {
        return this.httpRequest('alarm/searchTradingAreaDetail', param, 'post')
    }
	
	/**
	 * 获取营收详情
	 * @param param
	 * @returns {undefined}
	 */
	static getRevenueDetail(param) {
	    return this.httpRequest('alarm/searchRevenueDetail', param, 'post');
	}
	
	
	/**
	 * 获取收缴率详情
	 * @param {Object} param
	 */
	static getCollectionRateDetail(param) {
	    return this.httpRequest('alarm/searchCollectionRateDetail', param, 'post')
	}
	
	
	/**
	 * 获取租售比详情
	 * @param {Object} param
	 */
	static getRentSaleRateDetail(param) {
		return this.httpRequest('alarm/searchRentSaleRateDetail', param, 'post')
	}

    /**
     * 获取模板列表
     */
    static getTemplateList(param) {
        return this.httpRequest('alarm/getTemplateList', param, 'post');
    }


    /**
     * 获取模板详情
     */
    static getTemplateDetail(param) {
        return this.httpRequest('alarm/getTemplateDetail', param, 'post')
    }

    /**
     * 创建工单模板
     * @param param
     * @returns {*}
     */
    static createTemplate(param) {
        return this.httpRequest('alarm/createTemplate', param, 'post');
    }


    /**
     * 获取人员信息
     */
    static getUserInfo(param) {
        return this.httpRequest('alarm/getUserInfo', param, 'post')
    }


    /**
     * 获取预警报表
     * @param param
     * @returns {*}
     */
    static getOrderReport(param) {
        return this.httpRequest('alarm/orderReportList', param, 'post');
    }

    /**
     * 获取预警报表-员工
     * @param param
     * @returns {*}
     */
    static getOrderUserReport(param) {
        return this.httpRequest('alarm/orderUserReportList', param, 'post');
    }


    /**
     * 获取预警报表-类型
     * @param param
     * @returns {*}
     */
    static getOrderTypeReport(param) {
        return this.httpRequest('alarm/orderTypeReportList', param, 'post');
    }


    /**
     * 获取预警报表
     * @param param
     * @returns {*}
     */
    static getOrderTaskReport(param) {
        return this.httpRequest('alarm/orderTaskReportList', param, 'post');
    }

    /**
     * 获取预警报表-员工
     * @param param
     * @returns {*}
     */
    static getOrderTaskUserReport(param) {
        return this.httpRequest('alarm/orderTaskUserReportList', param, 'post');
    }


    /**
     * 获取预警报表-类型
     * @param param
     * @returns {*}
     */
    static getOrderTaskTypeReport(param) {
        return this.httpRequest('alarm/orderTaskTypeReportList', param, 'post');
    }


    static httpRequest(url, param, method ){
        if(method == 'get'){
            return httpGet(this.baseUrl + url, param);

        }
        if(method == 'post'){
            return httpPost(this.baseUrl + url, param);
        }
    }

    static handleResponse(response, scope, successFunc,errorFunc){
        let data = response.data;
        if(data.code == 200){
            if(successFunc && typeof successFunc == 'function'){
                successFunc(data.data);
            }
        }else{
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if(errorFunc && typeof errorFunc == 'function'){
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc){
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if(errorFunc && typeof errorFunc == 'function'){
            errorFunc(response);
        }
    }
}